module.exports = __webpack_public_path__ + "static/media/map.017424a5.png";